import React, { FC, ReactNode } from "react";

export interface NavItemProps {
  className?: string;
  radius?: string;
  onClick?: () => void;
  isActive?: boolean;
  renderX?: ReactNode;
  children?: ReactNode;
}

const NavItem: FC<NavItemProps> = ({
  className = "px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize",
  radius = "rounded-full",
  children,
  onClick = () => {},
  isActive = false,
  renderX,
}) => {
  return (
    <li className="nc-NavItem relative flex-shrink-0">
      {renderX && renderX}
      <button
        className={`flex items-center justify-center font-medium ${className} ${radius} ${
          isActive
            ? "bg-primary-900 text-primary-50 dark:bg-primary-100 dark:text-black"
            : "text-primary-500 dark:text-primary-400 dark:hover:text-primary-100 hover:text-primary-900 hover:bg-primary-100 dark:hover:bg-primary-800"
        } `}
        onClick={onClick}
      >
        {children}
      </button>
    </li>
  );
};

export default NavItem;
